export default __webpack_public_path__ + "static/media/trashcan.f269faca.svg";